var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0c1.104569 0 2 .895431 2 2 0 1.104569-.895431 2-2 2-1.104569 0-2-.895431-2-2C0 .895431.895431 0 2 0zm6 0c1.104569 0 2 .895431 2 2 0 1.104569-.895431 2-2 2-1.104569 0-2-.895431-2-2 0-1.104569.895431-2 2-2zm6 0c1.104569 0 2 .895431 2 2 0 1.104569-.895431 2-2 2-1.104569 0-2-.895431-2-2 0-1.104569.895431-2 2-2z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d6d1cf03315404f8f8a9bafd37e1712d.svg";
export { ForwardRef as ReactComponent };